var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wf-product-collection" }, [
    _c(
      "div",
      { staticClass: "wf-product-collection-results d-flex flex-wrap" },
      [
        _vm._l(_vm.sortedItems, function(item, index) {
          return _c("product-search-result", {
            key: item.styleNumber,
            attrs: { item: item, "product-index": index }
          })
        }),
        _vm._v(" "),
        _vm.showLoadMore
          ? _c("pc-load-more", {
              staticClass: "mb-5",
              attrs: { "load-more": _vm.onLoadMore }
            })
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }